import React from 'react';
import ExternalRedirect from './ExternalRedirect';

const App = () => {
  return (
    <div>
      <ExternalRedirect to="https://docs.google.com/forms/d/e/1FAIpQLSdMSLcuos_1XHc_fjHuRo_JE6MT4CNJ5OQKcvaqAVvYcVlJPQ/viewform?usp=dialog" />
    </div>
  );
};

export default App;
